import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/auth-context";
import { LAST_VISITED_LOCATION } from "../const/const";
 
// GK 2026-04-26 This allows us to designate specific pages to be used by admins only
const RequireAdminAuth = ({children}) => {
    const auth = useAuth();
    const lastLocation = localStorage.getItem(LAST_VISITED_LOCATION);

    return auth.userRole?.toLowerCase() !== 'admin' ? <Navigate to={ lastLocation ?? '/' } replace/> : children;
}

export default RequireAdminAuth;